export type Locale = 'pt-BR' | 'en';

export type ColorblindMode = 'off' | 'deutero';

export interface AudioSettings {
  masterVolume: number;
  sfxVolume: number;
  ambientVolume: number;
  musicVolume: number;
  muted: boolean;
}

export interface AccessibilitySettings {
  fontScale: number;
  reducedMotion: boolean;
  colorblindMode: ColorblindMode;
}

export interface CloudSettings {
  enabled: boolean;
}

export interface Settings {
  locale: Locale;
  audio: AudioSettings;
  accessibility: AccessibilitySettings;
  cloud: CloudSettings;
  fastMode: boolean;
  onboarded: boolean;
}

export const DEFAULT_SETTINGS: Settings = {
  locale: 'pt-BR',
  audio: {
    masterVolume: 0.8,
    sfxVolume: 1,
    ambientVolume: 0.6,
    musicVolume: 0.7,
    muted: false,
  },
  accessibility: {
    fontScale: 1,
    reducedMotion: false,
    colorblindMode: 'off',
  },
  cloud: {
    enabled: false,
  },
  fastMode: false,
  onboarded: false,
};

export function clampVolume(v: number): number {
  if (Number.isNaN(v)) return 0;
  return Math.min(1, Math.max(0, v));
}

export function clampFontScale(s: number): number {
  if (Number.isNaN(s)) return 1;
  return Math.min(1.5, Math.max(0.8, s));
}
